import { motion } from 'framer-motion'
import { Webhook, Plus } from 'lucide-react'
import { PageHeader, fadeUp } from '@personic/shared'
import { buildBreadcrumbs } from '@/config/routes'

export default function Webhooks() {
  const breadcrumbs = buildBreadcrumbs('/settings/integrations/webhooks')

  return (
    <div>
      <PageHeader
        title="Webhooks"
        description="Configure webhook endpoints to receive real-time event notifications."
        breadcrumbs={breadcrumbs}
        action={
          <button className="flex items-center gap-2 px-4 py-2 rounded-lg bg-copper-500 text-white text-sm font-medium hover:bg-copper-600 transition-colors">
            <Plus className="w-4 h-4" />
            Add Webhook
          </button>
        }
      />

      <motion.div variants={fadeUp} initial="hidden" animate="visible" className="max-w-4xl">
        <div className="rounded-xl border border-warm-200 bg-white p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-copper-50 flex items-center justify-center">
              <Webhook className="w-5 h-5 text-copper-500" />
            </div>
            <div>
              <h2 className="font-heading font-semibold text-midnight-800">Webhook Endpoints</h2>
              <p className="text-xs text-warm-500">Receive POST notifications for profile, session, and system events</p>
            </div>
          </div>

          <div className="text-sm text-warm-500 text-center py-8">
            No webhooks configured. Add a webhook endpoint to start receiving event notifications.
          </div>
        </div>
      </motion.div>
    </div>
  )
}
